import { I18nUtils } from "../../../../i18n/I18nUtils";

export class Nif {
    _nif;

    constructor(nif) {
        if (!nif)
            throw new Error(I18nUtils.tr('TR_CAMPO_OBLIGATORIO'));
        if (!this.isNifNieOrVat(nif)) {
            throw new Error(I18nUtils.tr('TR_NIF_INVALIDO'));
        }

        this._nif = nif;
    }

    get nif() {
        return this._nif;
    }

    isNifNiePersonValid(nif) {
        const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        const nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        const str = nif.toString().toUpperCase();

        if (!nifRexp.test(str) && !nieRexp.test(str)) {
            return false;
        }

        const nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');

        const letter = str.substr(-1);
        const charIndex = parseInt(nie.substr(0, 8), 10) % 23;

        return validChars.charAt(charIndex) === letter;
    }

    isNifCompanyValid(nif) {
        // Q 28 26004 J -> Letra - Provincia - Numeros - Letra/Numero
        const validChars = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'N', 'P', 'Q', 'R', 'S', 'U', 'V', 'W'];
        const str = nif.toString().toUpperCase();

        const firstLetter = str.substr(0, 1);
        if (!validChars.includes(firstLetter)) {
            return false;
        }

        const digits = str.substr(1, 7);
        let sumA = 0;
        let sumB = 0;
        for (let index = 0; index < digits.length; index++) {
            if (index % 2 !== 0) {
                sumA += parseInt(digits.charAt(index), 10);
            } else {
                const mult = parseInt(digits.charAt(index), 10) * 2;
                const result = Math.trunc(mult / 10);
                const rest = mult % 10;
                sumB += result + rest;
            }
        }
        const sumC = sumA + sumB;
        let unitDigit = sumC % 10;
        if (unitDigit !== 0) {
            unitDigit = 10 - unitDigit;
        }

        const relationValidLastLetter = {0: 'J', 1: 'A', 2: 'B', 3: 'C', 4: 'D', 5: 'E', 6: 'F', 7: 'G', 8: 'H', 9: 'I'};
        const validLastLetter = relationValidLastLetter[unitDigit];
        const toTestLastUnit = str.substr(-1, 1);

        if (/^[PQRSW]$/i.test(firstLetter)) { // la última unidad será una letra
            return validLastLetter === toTestLastUnit;
        } else if (/^[ABEH]$/i.test(firstLetter)) { // la última unidad será un número
            return parseInt(str.substr(-1, 1), 10) === unitDigit;
        } else { // número o letra
            return parseInt(str.substr(-1, 1), 10) === unitDigit || validLastLetter === toTestLastUnit;
        }
    }

    isVatCompanyValid(vat) {
        const vatReg = /^((AT)U[0-9]{8}|(BE)[0,1][0-9]{9}|(BG)[0-9]{9,10}|(CY)[0-9]{8}L|(CZ)[0-9]{8,10}|(DE)[0-9]{9}|(DK)[0-9]{8}|(EE)[0-9]{9}|(EL|GR)[0-9]{9}|(ES)[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)[0-9]{8}|(FR)[0-9A-Z]{2}[0-9]{9}|(GB)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HR)[0-9]{11}|(HU)[0-9]{8}|(IE)[0-9A-Z]{8,9}|(IT)[0-9]{11}|(LT)([0-9]{9}|[0-9]{12})|(LU)[0-9]{8}|(LV)[0-9]{11}|(MT)[0-9]{8}|(NL)[0-9A-Z]{12}|(PL)[0-9]{10}|(PT)[0-9]{9}|(RO)[0-9]{2,10}|(SE)[0-9]{12}|(SI)[0-9]{8}|(SK)[0-9]{10})$/
        return vatReg.test(vat);
    }

    isNifNieOrVat(str) {
        var trimmedStr = str.trim();
        return this.isNifNiePersonValid(trimmedStr) || this.isNifCompanyValid(trimmedStr) || this.isVatCompanyValid(trimmedStr);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/model/objectvalue/Nif.js